import { getTranslatedSubmissionStatusName } from '@module/assignment';
import { Button, Progress, Space, Tooltip } from 'antd';
import { PrimaryButton, styleVariables } from '@lib/common';
import { getDateTime } from '../../../../assignment-components';
import styled from 'styled-components';
import { EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import { SubmissionStatusComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledViolateButton = styled(PrimaryButton).withConfig({
  displayName: "examination-assignment-columns__StyledViolateButton",
  componentId: "sc-ggc37r-0"
})(["color:white;background:", ";border:none;&:hover,&:active,&:focus{background:", ";}"], styleVariables.colors.red4, styleVariables.colors.red4);
var percentThresholds = {
  low: 0,
  medium: 50,
  full: 100
};
var trailColors = {
  medium: '#FDE6B6',
  high: styleVariables.colors.blue2
};

var getProgressBar = function getProgressBar(percent) {
  var determineStrokeColor = percent <= percentThresholds.medium ? trailColors.medium : trailColors.high;
  return /*#__PURE__*/_jsx(Progress, {
    percent: percent,
    status: "active",
    strokeColor: determineStrokeColor
  });
};

export var getColumns = function getColumns(_ref) {
  var attendeeTranslation = _ref.attendeeTranslation,
      handleOpenViewSubmission = _ref.handleOpenViewSubmission,
      handleOpenViolateDetailModal = _ref.handleOpenViolateDetailModal,
      assignment = _ref.assignment;
  return [{
    title: attendeeTranslation.submitTime,
    dataIndex: 'submitTime',
    key: 'submitTime',
    render: function render(_, record) {
      if (!record.report.submitTime) {
        if (assignment.isEnded()) {
          return /*#__PURE__*/_jsx(_Fragment, {
            children: getDateTime(+assignment.endTime)
          });
        }

        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return getDateTime(parseInt(record.report.submitTime));
    }
  }, {
    title: attendeeTranslation.fullName,
    key: 'fullName',
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs("span", {
        children: [record.firstName, " ", record.lastName]
      });
    }
  }, {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.email
      });
    }
  }, {
    title: attendeeTranslation.submissionStatus,
    key: 'submissionStatus',
    render: function render(_, record) {
      if (!record.report.status) {
        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return /*#__PURE__*/_jsx(SubmissionStatusComponent, {
        statusType: record.report.status.id,
        text: getTranslatedSubmissionStatusName(record.report.status.id, record.report.status.name, attendeeTranslation)
      });
    }
  }, {
    title: attendeeTranslation.violate,
    dataIndex: 'violate',
    key: 'violate',
    render: function render(_, record) {
      var _record$report;

      return /*#__PURE__*/_jsx(Tooltip, {
        title: attendeeTranslation.clickToViewDetail,
        children: (record === null || record === void 0 ? void 0 : (_record$report = record.report) === null || _record$report === void 0 ? void 0 : _record$report.isViolatedSecurityOptions) && /*#__PURE__*/_jsx(StyledViolateButton, {
          onClick: function onClick() {
            return handleOpenViolateDetailModal(record);
          },
          children: attendeeTranslation.violateDetail
        })
      });
    }
  }, {
    title: attendeeTranslation.gradingStatus,
    key: 'gradingStatus',
    render: function render(_, record) {
      if (record.report.isOnGradingProcess()) {
        return /*#__PURE__*/_jsxs(Space, {
          children: [/*#__PURE__*/_jsx(LoadingOutlined, {}), /*#__PURE__*/_jsx("span", {
            children: attendeeTranslation.onGradingProcess
          })]
        });
      }

      return getProgressBar(record.report.gradedPercentage);
    }
  }, {
    title: attendeeTranslation.score,
    key: 'score',
    render: function render(_, record) {
      var score = record.report.score;

      if (score === null || score === undefined) {
        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return score;
    }
  }, {
    title: attendeeTranslation.action,
    key: 'action',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: attendeeTranslation.clickToViewDetail,
        children: /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return handleOpenViewSubmission(record);
          },
          children: /*#__PURE__*/_jsx(EyeOutlined, {})
        })
      });
    }
  }];
};